import ListingVM from './listing-vm';

export default {
  init: function() {
    var data = JSON.parse($('#coupons-json').val());
    const coupon_data = document.getElementById('coupon_data');
    ko.applyBindingsWithValidation(new ListingVM(data), coupon_data, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);

    Kadenze.Share.init();
    window.onload = function () {
      if (localStorage.justOnce != "true") {
        localStorage.setItem("justOnce", "true");
        window.location.reload();
      }
    }
  }
};
